import styles from './all-contracts-details-grid-renderer.module.scss';
import { GetCurrentCompany } from '../../customer-context/customer-context';
import { useState } from 'react';
import { ValueFormatterParams } from 'ag-grid-community';
import { useGetRequestNewHook, useTableConfigHook } from '../../requestUtils';
import FutureChangeIcon from 'libs/react-shared-lib/src/lib/future-change-icon/future-change-icon';
import { booleanHeader, Box, CreateHeaders, currencyHeader, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import { IAllContracts } from '../../_models/all-contracts';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface AllContractsDetailsGridRendererProps { data: IAllContracts }

export function AllContractsDetailsGridRenderer(props: AllContractsDetailsGridRendererProps) {
  const { t } = useTranslation();
  const currentCompany = GetCurrentCompany();
  const tableConfig = useTableConfigHook("AllContractsDetails");
  const [showOnlyActive, setShowOnlyActive] = useState<boolean>(props.data.isActive);
  const url = props.data.contractNumber === "Fremtidig" ?
    `contracts/${currentCompany?.number}/futureContractItems` :
    `contracts/${props.data.contractNumber}/contractItems/onlyActive/${showOnlyActive}`;
  const { data: items } = useGetRequestNewHook(url, [], [showOnlyActive]);

  const futureOrderRenderer = (params: ValueFormatterParams) => {
    const futureOrders = params.data.futureOrders;
    const futureOrder = futureOrders.length > 0 ? futureOrders[0] : undefined;
    return (
      futureOrder && <FutureChangeIcon item={futureOrder} />
    );
  };

  const headers = CreateHeaders([
    textHeader("licenseNumber", t('standard.licenseNumber'), HeaderSizeEnum.LARGE),
    booleanHeader("isModule", t('standard.module')),
    textHeader("name", t('standard.name'), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("licenseType", t('standard.type'), HeaderSizeEnum.MEDIUM),
    textHeader("vismaId", t('standard.item'), HeaderSizeEnum.LARGE),
    textHeader("futureOrders", t('standard.changes'), HeaderSizeEnum.LARGE, { renderer: futureOrderRenderer }),
    booleanHeader("isExpired", t('standard.expired')),
    textHeader("quantity", t('standard.seats'), HeaderSizeEnum.MEDIUM, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    currencyHeader("unitCost", t('allContractsDetailsGrid.pricePerItem'), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    textHeader("discountPercent", t('standard.discountPercent'), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    currencyHeader("acv", "ACV", HeaderSizeEnum.LARGE, {
      hide: true,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    currencyHeader("monthlyValue", t('allContractsDetailsGrid.monthlyValue'), HeaderSizeEnum.LARGE, {
      hide: true,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    currencyHeader("netGain", t('allContractsDetailsGrid.netGain'), HeaderSizeEnum.LARGE, {
      hide: true,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    currencyHeader("residualValue", t('standard.residualValue'), HeaderSizeEnum.LARGE, {
      hide: true,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    currencyHeader("residualValueAtYearStart", t('allContractsDetailsGrid.residualValueAtYearStart'), HeaderSizeEnum.LARGE, {
      hide: true,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    }),
    currencyHeader("totalCost", t('allContractsDetailsGrid.totalCost'), HeaderSizeEnum.LARGE, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header"
    })
  ]);

  return (
    <Box className="d-flex flex-column py-4 px-2">
      <WebkuaTable
        headers={headers}
        tableFilters={[{
          label: t('standard.activeOnly'),
          checked: showOnlyActive,
          onChange: (showOnlyActive) => setShowOnlyActive(showOnlyActive)
        }]}
        data={items}
        tableConfig={tableConfig}
      />
    </Box>
  );
}

export default AllContractsDetailsGridRenderer;